import { isFeatureEnabled } from "./appConfigurations";

// Shows when filters hide sites or alarms (CS AB#50050): amber views and
// controls, removable filter badges, the Sites count line. Only together with
// the organization filter (CS_49318_GLOBAL_ORG_FILTER); off = the pages as before.
export const FILTER_INDICATORS_FEATURE_FLAG = "CS_50050_FILTER_INDICATORS";

export const selectFilterIndicatorsFlag = isFeatureEnabled(
  FILTER_INDICATORS_FEATURE_FLAG
);
